import { ModuleRegistry, AllCommunityModule } from 'ag-charts-community';

// AG Charts v14 is modular and needs explicit registration before any standalone <AgCharts /> renders.
// The community bundle covers cartesian + polar (donut) series, axes and legends.
ModuleRegistry.registerModules([AllCommunityModule]);
